import api from '@/api'

export default {
  paginate(payload) {
    return new Promise(function(resolve, reject) {
      api
        .request('post', `/api/v1/influencers/search`, true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  searchKeyword(payload) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/search/keyword`, true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  async fetchLocalAudienceReport(instagramID, instagramHandle) {
    try {
      let report = await api.request('get', `/api/v1/social-data/audience/local/report?instagramID=${instagramID}&instagramHandle=${instagramHandle}`, true)
      return report
    } catch (error) {
      throw error
    }
  },

  async getUserPosts(instagramID, instagramHandle, keyword) {
    try {
      let report = await api.request('get', `/api/v1/influencers/posts?instagramID=${instagramID}&instagramHandle=${instagramHandle}&keyword=${keyword}`, true)
      if (report.status === 200) {
        return report.data
      }
      throw new Error('Server Error')
    } catch (error) {
      throw error
    }
  },

  async refreshAudienceReport(reportId) {
    try {
      let report = await api.request('get', `/api/v1/social-data/audience/reports/${reportId}`, true)
      return report
    } catch (error) {
      throw error
    }
  },

  // get Influencer Wordcloud for Admin
  getWordcloud(influencerID) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/influencers/wordcloud/' + influencerID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/InfluencerSearch/influencerSearchAPIs.js